import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import {
  OverlayBase,
  TiimeAlertModule,
  TiimeButtonModule,
  TiimeIconModule,
  TiimeInputContainerModule,
  TiimeTimelineModule,
  TiimeTooltipModule
} from 'tiime-material';

import { HistoryInfosOverlayData } from '@shared-components/history-infos-button/history-infos-overlay/history-infos-overlay-data';
import { StatusColorPipe } from '@shared-pipes/status-color/status-color.pipe';
import { StatusLabelPipe } from '@shared-pipes/status-label/status-label.pipe';
import { TimelineItemDescriptionPipe } from '@shared-pipes/timeline-item-description.pipe';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    TiimeIconModule,
    TiimeButtonModule,
    TiimeTimelineModule,
    StatusColorPipe,
    StatusLabelPipe,
    TiimeAlertModule,
    TiimeTooltipModule,
    TiimeInputContainerModule,
    TimelineItemDescriptionPipe
  ],
  selector: 'app-history-infos-overlay',
  templateUrl: './history-infos-overlay.component.html',
  styleUrls: ['./history-infos-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryInfosOverlayComponent extends OverlayBase<boolean, HistoryInfosOverlayData> {
  openHistoryDialog(): void {
    this.overlayRef.close(true);
  }
}
